var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetailFashion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "styler_FILL0_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 22V16H5.4C4.73333 16 4.16667 15.7667 3.7 15.3C3.23333 14.8333 3 14.2667 3 13.6C3 13.1167 3.13333 12.6708 3.4 12.2625C3.66667 11.8542 4.01667 11.55 4.45 11.35L11 8.45V7.8C10.4 7.58333 9.91667 7.22083 9.55 6.7125C9.18333 6.20417 9 5.63333 9 5C9 4.16667 9.29167 3.45833 9.875 2.875C10.4583 2.29167 11.1667 2 12 2C12.8333 2 13.5417 2.29167 14.125 2.875C14.7083 3.45833 15 4.16667 15 5H13C13 4.71667 12.9042 4.47917 12.7125 4.2875C12.5208 4.09583 12.2833 4 12 4C11.7167 4 11.4792 4.09583 11.2875 4.2875C11.0958 4.47917 11 4.71667 11 5C11 5.28333 11.0958 5.52083 11.2875 5.7125C11.4792 5.90417 11.7167 6 12 6C12.2833 6 12.5208 6.09583 12.7125 6.2875C12.9042 6.47917 13 6.71667 13 7V8.45L19.55 11.35C19.9833 11.55 20.3333 11.8542 20.6 12.2625C20.8667 12.6708 21 13.1167 21 13.6C21 14.2667 20.7667 14.8333 20.3 15.3C19.8333 15.7667 19.2667 16 18.6 16H17V22H7ZM5.4 14H7V13H17V14H18.6C18.7167 14 18.8125 13.9583 18.8875 13.875C18.9625 13.7917 19 13.6833 19 13.55C19 13.4667 18.9792 13.3958 18.9375 13.3375C18.8958 13.2792 18.8333 13.2333 18.75 13.2L12 10.2L5.25 13.2C5.16667 13.2333 5.10417 13.2792 5.0625 13.3375C5.02083 13.3958 5 13.4667 5 13.55C5 13.6833 5.0375 13.7917 5.1125 13.875C5.1875 13.9583 5.28333 14 5.4 14ZM9 20H15V15H9V20Z",
    fill: "#240b3b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailFashion);
export default __webpack_public_path__ + "static/media/retail-fashion.ce41ae5a8d7ed58ede14b31d3e54fb9b.svg";
export { ForwardRef as ReactComponent };